const VIEW_CURRENT_USER_LOCKS = 'VIEW_CURRENT_USER_LOCKS';

export const locksActions = {
  VIEW_CURRENT_USER_LOCKS,
};



// WEBPACK FOOTER //
// ./src/config/actionTypes.js